import React from "react";

function IconExpression() {
  const uid = Date.now();
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        fill={`url(#${uid})`}
        d="M22 11c0 6.075-4.925 11-11 11-6.074 0-11-4.925-11-11C0 4.926 4.926 0 11 0c6.075 0 11 4.926 11 11z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.2"
        d="M22 11c0 6.075-4.925 11-11 11-6.074 0-11-4.925-11-11C0 4.926 4.926 0 11 0c6.075 0 11 4.926 11 11z"
      ></path>
      <path
        fill="#292F33"
        d="M15.574 18.26c-.027-.11-.714-2.677-4.574-2.677-3.861 0-4.547 2.567-4.574 2.676a.305.305 0 00.336.376.31.31 0 00.175-.084c.012-.012 1.194-1.134 4.063-1.134 2.868 0 4.052 1.122 4.063 1.133a.306.306 0 00.511-.29zM9.599 9.345c-1.99-1.99-5.186-2.013-5.321-2.013a.612.612 0 00-.001 1.223c.018 0 1.176.014 2.434.45-.362.391-.6.998-.6 1.688 0 1.182.684 2.14 1.528 2.14s1.527-.958 1.527-2.14c0-.106-.011-.207-.022-.31.008 0 .015.005.022.005A.61.61 0 009.6 9.346zm8.123-2.013c-.135 0-3.331.024-5.32 2.013a.61.61 0 00.431 1.043c.008 0 .015-.004.022-.004-.01.102-.022.203-.022.31 0 1.181.684 2.138 1.528 2.138s1.528-.957 1.528-2.139c0-.69-.238-1.297-.6-1.688a8.536 8.536 0 012.434-.45.61.61 0 10-.001-1.223z"
      ></path>
      <path
        fill="#292F33"
        d="M18.174 20.167H3.826a1.385 1.385 0 01-1.382-1.382v-3.507a1.385 1.385 0 011.382-1.382h14.348a1.385 1.385 0 011.381 1.382v3.507a1.385 1.385 0 01-1.381 1.382z"
      ></path>
      <path
        fill="#fff"
        d="M4.792 16.64h-.5c-.192 0-.28-.14-.28-.28 0-.139.088-.278.28-.278h.58L5 15.147c.029-.209.116-.279.29-.279.14 0 .268.093.268.233 0 .087 0 .046-.012.14l-.116.842h.558l.128-.935c.029-.21.116-.279.29-.279.14 0 .268.092.268.232 0 .088 0 .047-.012.14l-.117.842h.5c.192 0 .279.14.279.279 0 .14-.087.28-.279.28h-.58l-.094.661h.5c.192 0 .279.14.279.28 0 .139-.088.278-.279.278H6.29l-.128.935c-.029.21-.116.279-.29.279-.14 0-.268-.093-.268-.233 0-.087 0-.046.011-.14l.117-.842h-.557l-.128.935c-.03.21-.116.279-.29.279-.14 0-.269-.092-.269-.232 0-.088 0-.047.012-.14l.116-.842h-.498c-.192 0-.28-.14-.28-.279 0-.14.088-.28.28-.28h.58l.094-.661zm.47.662h.552l.093-.662h-.552l-.093.662zm2.821-1.528c0-.505.378-.941.895-.941s.894.436.894.941c0 .505-.377.936-.894.936-.518 0-.895-.43-.895-.936zm1.197 0c0-.186-.111-.348-.302-.348-.192 0-.303.163-.303.348 0 .186.11.344.303.344.191 0 .302-.158.302-.344zm1.411-.79c.076-.144.134-.185.268-.185.18 0 .343.145.343.325 0 .046 0 .087-.047.174l-1.952 3.654c-.087.121-.122.191-.261.191-.151 0-.331-.145-.331-.319 0-.087.034-.168.058-.215l1.922-3.625zm-.563 3.19c0-.505.377-.941.895-.941.517 0 .894.436.894.94 0 .506-.377.936-.894.936-.518 0-.895-.43-.895-.935zm1.196 0c0-.186-.11-.348-.302-.348s-.303.162-.303.348c0 .186.111.343.303.343s.302-.157.302-.343zm1.52.482a.454.454 0 11.907.001.454.454 0 01-.907-.001zm.034-3.428c0-.243.18-.394.418-.394.233 0 .419.157.419.394v2.237c0 .238-.186.395-.419.395-.238 0-.418-.151-.418-.395v-2.237zm4.937 3.916a.312.312 0 01-.263-.12l-.443-.483-.044.04c-.429.395-.8.562-1.237.562-.678 0-1.362-.386-1.362-1.249 0-.676.53-1.081.846-1.262l.071-.04-.058-.06c-.26-.273-.366-.498-.366-.776 0-.659.601-.958 1.159-.958.467 0 1.124.277 1.124.891 0 .581-.54.917-.704 1.007l-.07.037.709.82.271-.328c.151-.181.24-.258.395-.258.125 0 .26.113.26.32 0 .155-.155.358-.306.535l-.181.205.431.512c.08.095.113.146.113.261a.357.357 0 01-.345.344zm-2.107-2.123c-.261.175-.527.406-.527.789 0 .4.26.659.665.659.337 0 .555-.148.78-.37l.043-.043-.917-1.065-.043.03zm.41-1.657c-.17 0-.409.14-.409.368 0 .213.105.342.326.568l.032.031.038-.02c.304-.159.458-.338.458-.53 0-.287-.23-.417-.444-.417z"
      ></path>
      <defs>
        <linearGradient
          id={uid}
          x1="11"
          x2="11"
          y1="0"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2F92ED"></stop>
          <stop offset="1" stopColor="#00CFAA"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default IconExpression;